import { ReactNode } from 'react';

import { cn } from '../../../../utils';
import useHtmlProcessor from '../../../utils/hooks/use-html-processor';
import { ComponentOverrides } from '../../../utils/hooks/use-abstract-processor';

interface RenderContentProps<T extends ComponentOverrides> {
    html?: string | Node | null;
    className?: string;
    fullWidth?: boolean;
    children?: ReactNode;
    overrides?: T;
}

const RenderContent = <T extends ComponentOverrides>(props: RenderContentProps<T>) => {
    const { html, className, fullWidth, children, overrides } = props;
    // @ts-ignore
    const { content } = useHtmlProcessor(html || '', overrides);

    return (
        <div
            className={cn(
                'post-content overflow-auto break-words whitespace-pre-line text-text-dark font-normal prose prose-base',
                fullWidth ? 'max-w-none' : '',
                className,
            )}
        >
            {html ? content : children}
        </div>
    );
};

export default RenderContent;
